import { API } from "@js/api";
import type { Talent } from "@js/types/freelancer";
import type { Job } from "@js/types/jobs";

export type UniversalSearchJobsResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: Job[];
};

export type UniversalSearchTalentResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  total_count: number | null;
  results: Talent[];
};

type UniversalSearchArgs = {
  search?: string;
  page_size?: number;
  page?: number;
};

type UniversalSearchPopularArgs = Omit<UniversalSearchArgs, "page_size">;

const universalSearchApi = API.injectEndpoints({
  endpoints: (build) => ({
    getUniversalSearchJobs: build.query<
      UniversalSearchJobsResponse,
      UniversalSearchArgs
    >({
      query: ({ search, page_size = 5 }) => ({
        method: "GET",
        url: `/job_search/`,
        params: { search, page_size },
      }),
    }),
    getUniversalSearchTalent: build.query<
      UniversalSearchTalentResponse,
      UniversalSearchArgs
    >({
      query: ({ search, page_size = 5 }) => ({
        method: "GET",
        url: `/talent/`,
        params: { search, page_size },
      }),
    }),

    getUniversalSearchPopularJobs: build.query<
      UniversalSearchJobsResponse,
      UniversalSearchPopularArgs
    >({
      query: ({ search }) => ({
        method: "GET",
        url: `/popular_jobs/`,
        params: { search },
      }),
      transformResponse: (response: UniversalSearchJobsResponse["results"]) => {
        return {
          count: response.length,
          next: null,
          previous: null,
          results: response,
        };
      },
    }),
    getUniversalSearchPopularTalent: build.query<
      UniversalSearchTalentResponse,
      UniversalSearchPopularArgs
    >({
      query: ({ search }) => ({
        method: "GET",
        url: `/popular_people/`,
        params: { search },
      }),
      transformResponse: (
        response: UniversalSearchTalentResponse["results"],
      ) => {
        return {
          count: response.length,
          total_count: null,
          next: null,
          previous: null,
          results: response,
        };
      },
    }),
  }),
});

export const {
  useGetUniversalSearchJobsQuery,
  useGetUniversalSearchTalentQuery,
  useGetUniversalSearchPopularJobsQuery,
  useGetUniversalSearchPopularTalentQuery,
} = universalSearchApi;
